import React, { useEffect, useState } from "react";
import { RouteComponentProps, useLocation } from "@reach/router";
import {
  APAlign,
  APColumn,
  APFormFieldText,
  APStack,
  APText,
  APSizedBox,
  APCard,
  APImage,
  getIt,
  APForm,
  useAPForm,
  APFormSubmit,
  launchDialog,
  APButton,
  APCenter,
  APScrollView,
  CONST_DEBUG,
  showErrorDialog,
  REGEX,
} from "ap-components";
import PartnerApis from "../../Services/PartnerApis";
import { handleErrorMessage, launchPage } from "../../Common/Utils";
import { AdvisorInfo, UserSignUP } from "./model/UserSignUpClass";
import { CircularProgress, Divider } from "@material-ui/core";
import OtpPasswordDialog from "./ClientOtpPasswordDialog";
import ReactHtmlParser from 'react-html-parser';

interface FormData {
  firstName: string;
  phoneNumber: string,
  email?: string
}


const SignUpPage = (props: RouteComponentProps) => {
  const location = useLocation();
  const advisorId = new URLSearchParams(location.search).get("advisor");
  const referrerId = new URLSearchParams(location.search).get("referrerId") || undefined
  // Converting to lowercase, so that even if the casing is changed it matches the condition
  const type = new URLSearchParams(location.search).get("type")?.toLowerCase();

  let control = useAPForm();

  const [advisorData, setAdvisorData] = useState<AdvisorInfo>();

  let [form] = useState<FormData>({
    firstName: CONST_DEBUG ? "Vigneshwaran" : "",
    phoneNumber: CONST_DEBUG ? "9943579825" : ""
  });

  const [downloadLink, setDownloadLink] = useState<string>("");

  async function getAdvisorData() {
    if (advisorId) {
      try {
        var response = await getIt(PartnerApis).getAdvisorInfo(
          advisorId
        );

        console.log(response);
        setAdvisorData(response);
      } catch (error) {
        console.log(error);
        handleErrorMessage(error);
      }
    }
  }

  useEffect(() => {
    getAdvisorData();
  }, [advisorId]);

  if (!advisorId) {
    if (!referrerId) {
      return <APCenter>
        URL Link is not proper, Please check the link.
      </APCenter>;
    }
    else {
      return <NilClientSignUpPage form={form} referrerId={referrerId} />
    }

  }
  if (!advisorData) {
    return <APCenter>
      <CircularProgress />
    </APCenter>
  }

  return (
    <APColumn mainAxisSize='max' crossAxisAlignment='center' mainAxisAlignment="start" style={{ padding: "20px" }}>
      <APScrollView >
        <APCard style={{ width: "95vw", maxWidth: "560px", }}>
          <APColumn crossAxisAlignment='stretch'>
            <APColumn crossAxisAlignment="center">
              <APImage
                style={{ maxHeight: "240px" }}
                src={advisorData.image_banner ? advisorData.image_banner : "https://assetplus-statics.s3.ap-south-1.amazonaws.com/banner_mini.png"}
              />
              <div style={{ marginTop: "-20px", marginBottom: "10px" }}>
                <APImage
                  src={advisorData.image_logo}
                  style={{
                    boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.5)",
                    maxHeight: "70px",
                    borderRadius: "2px",
                    backgroundColor: 'white'
                  }}
                />
              </div>
            </APColumn>
            {advisorData.title &&
              <>
                <APSizedBox height="10px"></APSizedBox>
                <APText variant="dialogTitle" style={{ textAlign: "center" }}>{advisorData.title}</APText>
              </>
            }
            {advisorData.subtitle && <>
              <APSizedBox height="8px" />
              <APText variant="dialogDescription" style={{ textAlign: "center" }}>
                {ReactHtmlParser(advisorData.subtitle)}
              </APText>
            </>}
            <APSizedBox height="20px"></APSizedBox>
            {!downloadLink ? (
              <APForm control={control}>
                <APColumn crossAxisAlignment="stretch">
                  <APFormFieldText
                    label="Name"
                    keyboardType="text"
                    onChanged={(e) => (form.firstName = e)}
                    initialValue={form.firstName}
                    validator={(v) => {
                      if (v.length === 0) {
                        return "Provide your name";
                      }
                      return null;
                    }}
                  />
                  <APFormFieldText
                    label="Phone Number"
                    keyboardType="number"
                    initialValue={form.phoneNumber}
                    onChanged={(e) => (form.phoneNumber = e)}
                    validator={(v) => {
                      if (v.length !== 10) {
                        return "Phone number has to be 10 digits";
                      }
                      return null;
                    }}
                  />
                  {
                    type === "nri" &&
                    <APFormFieldText
                      label="Email"
                      initialValue={form.email}
                      onChanged={(e) => (form.email = e)}
                      validator={(v) => {
                        if (!REGEX.EMAIL.test(v)) {
                          return "Invalid email";
                        }
                        return null;
                      }}
                    />
                  }

                  <APText style={{ textAlign: "center" }}>MFD: {advisorData.advisorName}</APText>

                  <APSizedBox height="20px" />
                  <APFormSubmit
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      if (await control.validate()) {
                        try {
                          await getIt(PartnerApis).generateOtp(
                            {
                              phoneNumber: form.phoneNumber,
                              email: form.email
                            }
                          );

                          const url: string = await launchDialog<string>(
                            (deferred) => (
                              <OtpPasswordDialog
                                deferred={deferred}
                                initialForm={{
                                  ...form,
                                  subAdvisorId: advisorId,
                                  refId: referrerId,

                                }}
                              />
                            )
                          );
                          setDownloadLink(url);
                        } catch (error) {
                          if (error instanceof Error) {
                            if (error.message.includes("has already been registered")) {
                              return setDownloadLink("https://www.assetplus.in/link/app");
                            }
                          }
                          handleErrorMessage(error);

                        }
                      }
                    }}
                  >
                    PROCEED
                  </APFormSubmit>
                </APColumn>
              </APForm>
            ) : (
              <APColumn mainAxisSize="min" gap="8px">
                <APSizedBox height="8px" />
                <Divider style={{ width: "350px" }}></Divider>
                <APText variant="maintext">Congratulations!</APText>
                <APText variant="maintext">
                  You have successfully registered.
                </APText>
                <APText
                  variant="cardSubText"
                >
                  You can now download the app by clicking the button
                  below
                </APText>
                <APSizedBox height="16px" />
                <APButton
                  variant="contained"
                  color="primary"
                  onClick={function (): void {
                    window.open(downloadLink);
                  }}
                >
                  OPEN/DOWNLOAD APP
                </APButton>
                <APSizedBox height="4px" />
                <APText variant="maintext">OR</APText>
                <APSizedBox height="4px" />
                <APButton
                  variant="contained"
                  color="primary"
                  onClick={function (): void {
                    window.open(downloadLink);
                  }}
                >
                  Click here to continue
                </APButton>
                <APSizedBox height="16px" />
                <APText variant="cardSubText">
                  After downloading, please go to Login.
                </APText>
              </APColumn>
            )}
          </APColumn>
        </APCard>
      </APScrollView>
    </APColumn>
  )
};

export default SignUpPage;



function NilClientSignUpPage({ form, referrerId }: { form: FormData, referrerId: string }) {
  let control = useAPForm();
  const [downloadLink, setDownloadLink] = useState<string>("");
  return <APColumn mainAxisSize='max' crossAxisAlignment='center' mainAxisAlignment="start" style={{ padding: "20px" }}>
    <APScrollView>
      <APCard style={{ width: "95vw", maxWidth: "560px", }}>

        <APImage
          style={{ maxHeight: "240px", borderRadius: "4px" }}
          src="/img/assetplus_banner.png"
        />
        <APSizedBox height="32px" />
        {
          !downloadLink ?
            <APForm control={control}>
              <APColumn crossAxisAlignment="stretch">
                <APFormFieldText
                  label="Name"
                  keyboardType="text"
                  onChanged={(e) => (form.firstName = e)}
                  initialValue={form.firstName}
                  validator={(v) => {
                    if (v.length === 0) {
                      return "Provide your name";
                    }
                    return null;
                  }}
                />
                <APFormFieldText
                  label="Phone Number"
                  keyboardType="number"
                  initialValue={form.phoneNumber}
                  onChanged={(e) => (form.phoneNumber = e)}
                  validator={(v) => {
                    if (v.length !== 10) {
                      return "Phone number has to be 10 digits";
                    }
                    return null;
                  }}
                />



                <APSizedBox height="20px" />
                <APFormSubmit
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    if (await control.validate()) {
                      try {
                        await getIt(PartnerApis).generateOtp(
                          {
                            phoneNumber: form.phoneNumber,
                            email: form.email
                          }
                        );

                        const url: string = await launchDialog<string>(
                          (deferred) => (
                            <OtpPasswordDialog
                              deferred={deferred}
                              initialForm={{
                                ...form,
                                refId: referrerId,

                              }}
                            />
                          )
                        );
                        setDownloadLink(url);
                      } catch (error) {
                        if (error instanceof Error) {
                          if (error.message.includes("has already been registered")) {
                            return setDownloadLink("https://www.assetplus.in/link/app");
                          }
                        }
                        handleErrorMessage(error);

                      }
                    }
                  }}
                >
                  PROCEED
                </APFormSubmit>
              </APColumn>
            </APForm> :
            (
              <APColumn mainAxisSize="min" gap="8px">
                <APSizedBox height="8px" />
                <Divider style={{ width: "350px" }}></Divider>
                <APText variant="maintext">Congratulations!</APText>
                <APText variant="maintext">
                  You have successfully registered.
                </APText>
                <APText
                  variant="cardSubText"
                >
                  You can now download the app by clicking the button
                  below
                </APText>
                <APSizedBox height="16px" />
                <APButton
                  variant="contained"
                  color="primary"
                  onClick={function (): void {
                    window.open(downloadLink);
                  }}
                >
                  OPEN/DOWNLOAD APP
                </APButton>
                <APSizedBox height="4px" />
                <APText variant="maintext">OR</APText>
                <APSizedBox height="4px" />
                <APButton
                  variant="contained"
                  color="primary"
                  onClick={function (): void {
                    window.open(downloadLink);
                  }}
                >
                  Click here to continue
                </APButton>
                <APSizedBox height="16px" />
                <APText variant="cardSubText">
                  After downloading, please go to Login.
                </APText>
              </APColumn>
            )
        }

      </APCard>
    </APScrollView>
  </APColumn>

}